import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ma-4" }
const _hoisted_2 = { class: "d-flex align-start" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: _ctx.show,
    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.show) = $event)),
    width: "800",
    transition: "dialog-bottom-transition",
    class: "dialog"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_v_list, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_list_item, { class: "optionsBtns" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      size: "x-large",
                      color: "primary",
                      variant: "text",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateOptions()))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => _cache[21] || (_cache[21] = [
                            _createTextVNode("mdi-check-bold")
                          ])),
                          _: 1,
                          __: [21]
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      size: "x-large",
                      color: "secondary",
                      variant: "text",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeDialog()))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, null, {
                          default: _withCtx(() => _cache[22] || (_cache[22] = [
                            _createTextVNode("mdi-close")
                          ])),
                          _: 1,
                          __: [22]
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_list_item, { title: "Pompts" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_expansion_panels, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_expansion_panel, {
                          title: "Agent Role",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.trackPanelExpansion('prompt_agent_role')))
                        }, {
                          text: _withCtx(() => [
                            _cache[23] || (_cache[23] = _createElementVNode("div", { class: "text-subtitle-2" }, " Create agent prompts based on agent name and description. You can use <name> and <description> to dynamically fill in the agent's name and description. ", -1)),
                            _createVNode(_component_v_textarea, {
                              label: "Agent role prompt",
                              modelValue: _ctx.agentPrompt,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.agentPrompt) = $event)),
                              class: "mt-2"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_expansion_panel, {
                          title: "Squad Workflow",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.trackPanelExpansion('prompt_squad_workflow')))
                        }, {
                          text: _withCtx(() => [
                            _cache[24] || (_cache[24] = _createElementVNode("div", { class: "text-subtitle-2" }, " Create the squad workflow message from all of the agent names and descriptions. You can use <name>, <description> and <squadData> to dynamically fill in the squad name and description as well as all of the names and descriptions for the agents. ", -1)),
                            _createVNode(_component_v_textarea, {
                              label: "Squad workflow prompt",
                              modelValue: _ctx.squadPromptInternal,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.squadPromptInternal) = $event)),
                              class: "mt-2"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_expansion_panel, {
                          title: "First Agent",
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.trackPanelExpansion('prompt_first_agent')))
                        }, {
                          text: _withCtx(() => [
                            _cache[25] || (_cache[25] = _createElementVNode("div", { class: "text-subtitle-2" }, " Prompt for the leader model to determine the first agent. This needs to return only the agent name, or it will pick the first instance of an agent's name in the response. You can use <names> to dynamically fill in the list of agent names, and <workflow> to dynamically fill in the squad's workflow. ", -1)),
                            _createVNode(_component_v_textarea, {
                              label: "First agent prompt",
                              modelValue: _ctx.firstAgentPromptInternal,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.firstAgentPromptInternal) = $event)),
                              class: "mt-2"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_expansion_panel, {
                          title: "Leader",
                          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.trackPanelExpansion('prompt_leader')))
                        }, {
                          text: _withCtx(() => [
                            _cache[26] || (_cache[26] = _createElementVNode("div", { class: "text-subtitle-2" }, " Prompt for the leader agent to determine the agent to route the reponse to. You can use <workflow> to fill in the squad's workflow, <names> to fill in the list of agent names in the squad, as well as <agentName> and <agentResponse> to dynamically fill in the responding agent's name and response. ", -1)),
                            _createVNode(_component_v_textarea, {
                              label: "Leader prompt",
                              modelValue: _ctx.leaderPromptInternal,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.leaderPromptInternal) = $event)),
                              class: "mt-2"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_expansion_panel, {
                          title: "Open RAG Template",
                          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.trackPanelExpansion('prompt_open_rag')))
                        }, {
                          text: _withCtx(() => [
                            _createVNode(_component_v_textarea, {
                              label: "Open RAG Template",
                              modelValue: _ctx.openRAGTemplateInternal,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.openRAGTemplateInternal) = $event)),
                              class: "mt-2"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_expansion_panel, {
                          title: "Closed RAG Template",
                          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.trackPanelExpansion('prompt_closed_rag')))
                        }, {
                          text: _withCtx(() => [
                            _createVNode(_component_v_textarea, {
                              label: "Closed RAG Template",
                              modelValue: _ctx.closedRAGTemplateInternal,
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.closedRAGTemplateInternal) = $event)),
                              class: "mt-2"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_expansion_panel, {
                          title: "Code RAG Template",
                          onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.trackPanelExpansion('prompt_code_rag')))
                        }, {
                          text: _withCtx(() => [
                            _createVNode(_component_v_textarea, {
                              label: "Code RAG Template",
                              modelValue: _ctx.codeRAGTemplateInternal,
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.codeRAGTemplateInternal) = $event)),
                              class: "mt-2"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_list_item, { title: "Data" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_expansion_panels, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_expansion_panel, {
                          title: "Import / Export",
                          onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.trackPanelExpansion('data_import_export')))
                        }, {
                          text: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                              variant: "outlined",
                              class: "downloadConfig mt-4 mr-4",
                              onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.downloadConfig()))
                            }, {
                              default: _withCtx(() => _cache[27] || (_cache[27] = [
                                _createTextVNode(" export config ")
                              ])),
                              _: 1,
                              __: [27]
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_list_item, { title: "Utility Agents" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_expansion_panels, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_expansion_panel, {
                          title: "Summary Agent (for chat titles)",
                          onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.trackPanelExpansion('summary_agent')))
                        }, {
                          text: _withCtx(() => [
                            _createElementVNode("div", _hoisted_2, [
                              _createVNode(_component_v_select, {
                                modelValue: _ctx.selectedTitleAgent,
                                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.selectedTitleAgent) = $event)),
                                label: "Summary Agent",
                                items: _ctx.summaryAgentItems,
                                "item-title": "title",
                                "item-value": "value",
                                clearable: "",
                                "hide-details": "",
                                class: "d-inline-block text-area-width"
                              }, null, 8, ["modelValue", "items"])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}